/**
 * App-wide theme color semantic tokens — switch via `data-theme-color` on an ancestor.
 * @see https://www.chakra-ui.com/docs/theming/semantic-tokens
 */

import { avatarTokens } from "./avatar";
import { bgTokens } from "./bg";
import { blurTokens } from "./blur";
import { borderTokens } from "./border";
import { fgTokens } from "./fg";
import { formTokens } from "./form";
import { iconToken } from "./icon";
import { importMenuTokens } from "./import_menu";
import { navTokens } from "./nav";
import { popoverTokens } from "./popover";
import { railTokens } from "./rail";
import { statusTokens } from "./status";
import { subTokens } from "./sub";
import { uploadTokens } from "./upload";
import { utilityTokens } from "./utility";

export { themeColor } from "./_helpers";
export type { ThemeColorConditions } from "./_helpers";
export { themeColorSemanticShadows } from "./shadows";

export const themeColorSemanticColors = {
  themeColor: {
    fg: fgTokens,
    nav: navTokens,
    sub: subTokens,
    rail: railTokens,
    utility: utilityTokens,
    upload: uploadTokens,
    avatar: avatarTokens,
    popover: popoverTokens,
    blur: blurTokens,
    bg: bgTokens,
    border: borderTokens,
    status: statusTokens,
    form: formTokens,
    importMenu: importMenuTokens,
    icon: iconToken,
  },
};
